import React from 'react';
import { getStudioGallery } from '../config/imageRegistry';
import GalleryPage from '../components/GalleryPage';

const VirtualTourPage = () => {
  // Get all studio images from dynamic gallery
  const studioImageSources = getStudioGallery();
  const studioImages = studioImageSources.map((src, index) => ({
    src,
    alt: `Studio View ${index + 1}`
  }));

  return (
    <GalleryPage
      title={<>Virtual <em>Studio Tour</em></>}
      description="Explore our beautifully designed space. Natural light floods through large windows, creating an atmosphere of calm and focus. Every detail has been curated for your peaceful practice."
      images={studioImages}
      backButtonText="← Back to Our Studio"
      backButtonLink="/#studio"
    />
  );
};

export default VirtualTourPage;